<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="操作状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">禁用</a-select-option>
                  <a-select-option :value="1">正常</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="工作状态" prop="isWork">
                <a-select v-model="queryParam.isWork" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">下班</a-select-option>
                  <a-select-option :value="1">上班</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <!-- 查看/修改 -->
      <card-form
        ref="cardForm"
        @ok="getList"
      />
      <client-form
        ref="clientForm"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2200 }"
      >
        <span slot="status" slot-scope="text, record">
          <div>
            <a-switch @click="updateStatus(record)" v-model="record.status == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="isWork" slot-scope="text, record">
          <div>
            <a-switch @click="updateIsWork(record)" v-model="record.isWork == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="wxCodeUrl" slot-scope="text, record">
          <img
            v-viewer
            style="width: 20px;height: 20px;margin-right: 5px;margin-bottom: 5px"
            :src="record.wxCodeUrl"
          />
        </span>
        <span slot="shareQrUrl" slot-scope="text, record">
          <img
            v-viewer
            style="width: 20px;height: 20px;margin-right: 5px;margin-bottom: 5px"
            :src="record.shareQrUrl"
          />
        </span>
        <span slot="address" slot-scope="text, record">
          <div>{{ record.province }}{{ record.city }}{{ record.county }}{{ record.address }}</div>
        </span>
        <span slot="cardAddress" slot-scope="text, record">
          <div>{{ record.cardProvince }}{{ record.cardCity }}{{ record.cardCounty }}{{ record.cardAddress }}</div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.cardForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>专员名片
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.clientForm.handleQuery(record)">
            <a-icon type="user"/>客户列表
          </a>
<!--          <a-divider type="vertical"/>-->
<!--          <a @click="$refs.cardForm.handleUpdate1(record, undefined)">-->
<!--            <a-icon type="edit"/>岗位名片-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTopUser, updateUser } from '@/api/biz/user'
import { listCompany } from '@/api/user/company'
import CardForm from './modules/CardForm'
import ClientForm from './modules/ClientForm'
import { tableMixin } from '@/store/table-mixin'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)
// 设置初始值
VueViewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

export default {
  name: 'TopIndex',
  components: {
    ClientForm,
    CardForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      operateTitle: null,
      operateOpen: false,
      operateType: null,
      userId: null,
      interviewType: null,
      selectedRowKeys: [],
      selectedRows: [],
      remark: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      companyList: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickname: null,
        mobile: null,
        isWork: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'nickname',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: 180,
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          width: 80,
          align: 'center',
          customRender: function (sex) {
            if (sex === 0) {
              return '保密'
            } else if (sex === 1) {
              return '男'
            } else if (sex === 2) {
              return '女'
            }
          }
        },
        {
          title: '微信号',
          dataIndex: 'wxCode',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '微信二维码',
          dataIndex: 'wxCodeUrl',
          ellipsis: true,
          scopedSlots: { customRender: 'wxCodeUrl' },
          width: 120,
          align: 'center'
        },
        {
          title: '分享小程序码',
          dataIndex: 'shareQrUrl',
          ellipsis: true,
          scopedSlots: { customRender: 'shareQrUrl' },
          width: 120,
          align: 'center'
        },
        {
          title: '所在地',
          dataIndex: 'cardAddress',
          width: 350,
          scopedSlots: { customRender: 'cardAddress' },
          align: 'center'
        },
        {
          title: '定位所在地',
          dataIndex: 'address',
          width: 350,
          scopedSlots: { customRender: 'address' },
          align: 'center'
        },
        {
          title: '操作状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
          align: 'center'
        },
        {
          title: '工作状态',
          dataIndex: 'isWork',
          scopedSlots: { customRender: 'isWork' },
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    updateStatus(record) {
      // 更改状态
      record.status = (record.status === 0) ? 1 : 0
      updateUser(record).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    updateIsWork(record) {
      // 更改状态
      record.isWork = (record.isWork === 0) ? 1 : 0
      updateUser(record).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageTopUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
      this.queryCompanyList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        realName: null,
        mobile: null,
        education: null,
        sex: null,
        isWork: null,
        companyId: null,
        interviewTime: null,
        entryTime: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleStatus(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$refs.setStatusForm.handleAdd(ids)
      that.onSelectChange([], [])
      that.getList()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delReport(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
